import connectAsync from '../../utils/connectAsync';
import fetchMeAndProducts from '../../utils/connectors/fetchMeAndProducts';
import fetchPartner from '../../utils/connectors/fetchPartner';
import PremiumUpsellRoute from './PremiumUpsellRoute';

export default connectAsync([fetchMeAndProducts, fetchPartner])(PremiumUpsellRoute);
